import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import EditWebinarForm from 'components/Admin/Webinar/EditWebinarForm';
import actions from 'actions';
import constants from 'constants';
import validator from 'services/validator';
import inputFormatter from 'services/userInputFormatter';
import _ from 'lodash';
import shortid from 'shortid';
const { CPD_STATUSES } = constants;

const {
  UPDATE_WEBINAR_SAGA
} = constants;

const {
  updateWebinarSaga,
  cleanErrors,
  loadAdminWebinarSaga,
  loadSponsorsSuggestionsSaga
} = actions;

class EditWebinar extends Component {
  static propTypes = {
    createWebinar: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj
  };

  constructor(props) {
    super(props);
    this.state = {
      webinar: {
        webinar_type: 'online',
        start_date: moment().set(0, 'seconds'),
        end_date: moment().set(0, 'seconds'),
        webinar_title: '',
        expert_name: '',
        doctor_type: '',
        status: 'published',
        work_location: '',
        sponsor_id: '',
        int_cpd_points: '',
        ext_cpd_points: '',
        cpd_points: 'external',
        vimeo_url: '',
        doctor_avatar: '',
        icgp_ref: '',
        counties: [],
        disciplines: [],
        assignedUsers: [],
        user_types: [],
         ...props.webinar,
        spd_quizzes_attributes: [...(this.props.webinar.spd_quizzes || []), {
          question: '',
          correct: false
        }].map(
          quiz => ({...quiz, __id: shortid.generate()})
        )
      }
    }
  }

  componentWillReceiveProps(props) {
    if (!_.isEqual(this.props.webinar, props.webinar))
      console.log('^^^^^^^^^^^^^^^^^^', this.props.webinar.assigned_ids);
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...props.webinar,
          start_date: moment(props.webinar.start_date || this.state.webinar.start_date),
          assignedUsers: props.webinar.assigned_ids || this.props.webinar.assigned_ids,
          end_date: moment(props.webinar.end_date || this.state.webinar.end_date),
          spd_quizzes_attributes: [...(props.webinar.spd_quizzes || []), {
            question: '',
            correct: false
          }].map(
            quiz => ({...quiz, __id: shortid.generate()})
          )
        }
      });
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadWebinar(this.props.params.id);
    this.props.loadAllSponsors();
  }

  onConsultantOrHD = (allCounties) => {
    let newWebinar = {};

    const selectedAllCounties = _.isEqual(allCounties, this.state.webinar.counties);
    if (!this.state.webinar.counties || !selectedAllCounties) {
      newWebinar = {...newWebinar, ...{counties: allCounties.map(county => county)}}
    }

    if (this.state.webinar.ext_cpd_points !== 0 && this.state.webinar.int_cpd_points !== 0) {
      newWebinar = {...newWebinar, ...{ext_cpd_points: 0, int_cpd_points: 0}}
    }

    if (!_.isEmpty(newWebinar)) {
      this.setState({ webinar: {...this.state.webinar, ...newWebinar }});
    }
  }


  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const webinarData = { ...this.state.webinar,
      ...{
        [e.target.name]: input
      }
    }

    this.setState({ webinar: webinarData });
  }

  onCountiesChange = (counties) => {
    this.onFieldChange({
      target: {
        name: 'counties',
        value: (counties || []).map(county => county.value)
      }
    });
  }

  onUserTypeChange = (roles) => {
    this.onFieldChange({
      target: {
        name: 'user_types',
        value: (roles || []).map(role => role.value)
      }
    });
  }

  onDisciplinesChange = (disciplines) => {
    this.onFieldChange({
      target: {
        name: 'disciplines',
        value: (disciplines || []).map(discipline => discipline.value)
      }
    });
  }

  onAssignedUsersChange = (assignedUsers) => {
    this.onFieldChange({
      target: {
        name: 'assignedUsers',
        value: (assignedUsers || []).map(assignedUser => assignedUser.value)
      }
    });
  }

  onWebinarTypeChange = e => {
    const webinarData = { ...this.state.webinar,
      ...{
        webinar_type: e.target.value
      }
    }

    this.setState({ webinar: webinarData });
  };

  onCpdPointsChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const cpds = {
      ...(this.state.webinar.cpd_points == 'internal' ? {
        [e.target.name]: input,
        ext_cpd_points: 0
      } : {}),
      ...(this.state.webinar.cpd_points == 'external' ? {
        [e.target.name]: input,
        int_cpd_points: 0
      } : {}),
      ...(this.state.webinar.cpd_points == 'both' ? {
        [e.target.name]: input,
      } : {}),
    }
    const webinarData = { ...this.state.webinar, ...cpds };

    this.setState({ webinar: webinarData });
  }

  onCpdTypeChange = (e) => {
    const value = e.target.value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        cpd_status: e.target.value,
        ...(value !== CPD_STATUSES.granted ? {
          ext_cpd_points: 0,
          int_cpd_points: 0,
          icgp_ref: ''
        } : {})
      }
    });
  }


  onDateChange = (field, value) => {
    const webinarData = { ...this.state.webinar,
      ...{
        [field]: value
      }
    }

    this.setState({ webinar: webinarData });
  }

  onQuizAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: [
            ...this.state.webinar.spd_quizzes_attributes,
            ...[ { question: '', correct: false , __id: shortid.generate() } ],
          ]
        }
      }
    });
  }

  onQuizRemove = (__id) => {
    let quizzes = this.state.webinar.spd_quizzes_attributes.slice();
    const quiz = quizzes.find(quiz => quiz.__id == __id)
    if (quiz.id) {
      this.onQuizChange(__id, '_destroy', true)
    } else {
      quizzes = quizzes.filter(quiz => quiz.__id != __id);
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            spd_quizzes_attributes: quizzes
          }
        }
      });
    }
  }

  onQuizChange = (__id, field, value) => {
    let cpdQuiz = this.state.webinar.spd_quizzes_attributes.slice();
    let quiz = cpdQuiz.find(webinar => webinar.__id == __id);
    quiz[field] = value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: cpdQuiz
        }
      }
    });
  }

  cpdPointsFields = () => {
    const { cpd_points, cpd_status } = this.state.webinar;
    if (cpd_status !== CPD_STATUSES.granted) {
      return [];
    }
    switch (cpd_points) {
      case 'external':
        return ['ext_cpd_points']
      case 'internal':
        return ['int_cpd_points']
      case 'both':
        return ['int_cpd_points', 'ext_cpd_points']
      default:
        return []
    }
  }

  onSubmit = () => {
    this.props.updateWebinar(this.state.webinar)
  }

  render() {
    const {
      errors,
      errorsFrontend,
      sponsors
    } = this.props;
    return (
      <main className="site--width clearfix-c">
        <EditWebinarForm
          onFieldChange={this.onFieldChange}
          webinar={this.state.webinar}
          onQuizAdd={this.onQuizAdd}
          onQuizChange={this.onQuizChange}
          onDateChange={this.onDateChange}
          onSubmit={this.onSubmit}
          onQuizRemove={this.onQuizRemove}
          errors={validator.formatErrors(errors, errorsFrontend)}
          cpdPointsFields={this.cpdPointsFields()}
          onCpdPointsChange={this.onCpdPointsChange}
          onCountiesChange={this.onCountiesChange}
          onDisciplinesChange={this.onDisciplinesChange}
          onAssignedUsersChange={this.onAssignedUsersChange}
          onUserTypeChange={this.onUserTypeChange}
          onCpdTypeChange={this.onCpdTypeChange}
          sponsorsOptions={sponsors}
          onConsultantOrHD={this.onConsultantOrHD}
          onWebinarTypeChange={this.onWebinarTypeChange}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[UPDATE_WEBINAR_SAGA],
    errorsFrontend: state.errors[`${UPDATE_WEBINAR_SAGA}_FRONTEND`],
    webinar: state.webinars.tmp,
    sponsors: state.suggestions.sponsor.values
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateWebinar: (webinar) => dispatch(updateWebinarSaga(webinar)),
    cleanErrors: () => dispatch(cleanErrors(UPDATE_WEBINAR_SAGA)),
    loadWebinar: (id) => dispatch(loadAdminWebinarSaga(id, true)),
    loadAllSponsors: () => dispatch(loadSponsorsSuggestionsSaga()),
    dispatch: dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditWebinar);



/** WEBPACK FOOTER **
 ** ./src/containers/Admin/Webinar/EditWebinar.jsx
 **/